import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '917073620688';
const DEFAULT_MESSAGE = 'Hello, I would like to inquire about your design services.';

const updateBrowserChromeInset = () => {
  const viewport = window.visualViewport;
  if (!viewport) return;

  const chromeBottom = Math.max(
    0,
    window.innerHeight - viewport.height - viewport.offsetTop
  );

  document.documentElement.style.setProperty(
    '--browser-chrome-bottom',
    `${chromeBottom}px`
  );
};

const FloatingWhatsAppButton = () => {
  const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  useEffect(() => {
    updateBrowserChromeInset();

    const viewport = window.visualViewport;
    viewport?.addEventListener('resize', updateBrowserChromeInset);
    viewport?.addEventListener('scroll', updateBrowserChromeInset);
    window.addEventListener('resize', updateBrowserChromeInset);

    return () => {
      viewport?.removeEventListener('resize', updateBrowserChromeInset);
      viewport?.removeEventListener('scroll', updateBrowserChromeInset);
      window.removeEventListener('resize', updateBrowserChromeInset);
      document.documentElement.style.removeProperty('--browser-chrome-bottom');
    };
  }, []);

  return createPortal(
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed-safe-bottom-right inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-2xl hover:bg-[#1ebe5d] transition-all duration-300 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#25D366]/40"
    >
      <MessageCircle size={28} />
    </a>,
    document.body
  );
};

export default FloatingWhatsAppButton;
